import ageGateTextOverride from './ageGateTextOverride'
import banner from './banner'
import bannerTextOverride from './bannerTextOverride'
import build from './build'
import category from './category'
import consent from './consent'
import language from './language'
import disableCookies from './disableCookies'
import reports from './reports'

const cookies = {
  ageGateTextOverride,
  banner,
  bannerTextOverride,
  build,
  category,
  consent,
  language,
  disableCookies,
  reports,
}

export default cookies
